import React from "react";
import { Info } from "lucide-react";
import FleetrifyTooltip from "./tooltip";

interface InfoTooltipProps {
  title?: string;
  text: string;
  position?: "top" | "bottom" | "left" | "right";
  iconSize?: number;
  className?: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  title,
  text,
  position = "top",
  iconSize = 13,
  className = "",
}) => (
  <FleetrifyTooltip
    position={position}
    contentClassName="whitespace-normal w-64 leading-relaxed"
    content={
      <>
        {title && <span className="font-semibold block mb-1">{title}</span>}
        {text}
      </>
    }
  >
    <Info
      size={iconSize}
      className={`text-gray-400 hover:text-[#143887] cursor-help transition-colors ${className}`}
    />
  </FleetrifyTooltip>
);

export default InfoTooltip;
